import * as i0 from '@angular/core';
import { Directive, InjectionToken, EventEmitter, TemplateRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, ViewChild, ContentChild, Output, HostListener, Optional, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { MatMenuContent, matMenuAnimations, MatMenuModule } from '@angular/material/menu';
import { Subject, Subscription, merge } from 'rxjs';
import { ESCAPE, RIGHT_ARROW, LEFT_ARROW } from '@xpo-ltl/ngx-ltl-core/utils';
import * as i3 from '@angular/cdk/a11y';
import { isFakeMousedownFromScreenReader } from '@angular/cdk/a11y';
import * as i1 from '@angular/cdk/overlay';
import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take, delay } from 'rxjs/operators';
import * as i2 from '@angular/cdk/bidi';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

var ClosedEmitterTypes;
(function (ClosedEmitterTypes) {
    ClosedEmitterTypes["Click"] = "click";
    ClosedEmitterTypes["Keydown"] = "keydown";
    ClosedEmitterTypes["Tab"] = "tab";
})(ClosedEmitterTypes || (ClosedEmitterTypes = {}));

var TriggerType;
(function (TriggerType) {
    TriggerType["Click"] = "click";
    TriggerType["Hover"] = "hover";
})(TriggerType || (TriggerType = {}));

class XpoPopoverTitle {
}
XpoPopoverTitle.ɵfac = function XpoPopoverTitle_Factory(t) { return new (t || XpoPopoverTitle)(); };
XpoPopoverTitle.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPopoverTitle, selectors: [["xpo-popover-title"]], hostAttrs: [1, "xpo-Popover-title"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverTitle, [{
        type: Directive,
        args: [{
                selector: 'xpo-popover-title',
                host: { class: 'xpo-Popover-title' },
            }]
    }], null, null); })();

function XpoPopover_ng_template_0_div_5_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function XpoPopover_ng_template_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵtemplate(2, XpoPopover_ng_template_0_div_5_button_2_Template, 3, 0, "button", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.hideCloseButton);
} }
function XpoPopover_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵlistener("keydown", function XpoPopover_ng_template_0_Template_div_keydown_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.handleKeydown($event); })("@transformMenu.start", function XpoPopover_ng_template_0_Template_div_animation_transformMenu_start_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.isAnimating = true; })("@transformMenu.done", function XpoPopover_ng_template_0_Template_div_animation_transformMenu_done_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.onAnimationDone($event); })("mouseleave", function XpoPopover_ng_template_0_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onMouseLeave(); })("mouseover", function XpoPopover_ng_template_0_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onMouseOver(); });
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 2);
    i0.ɵɵelement(3, "polygon", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, XpoPopover_ng_template_0_div_5_Template, 3, 1, "div", 5);
    i0.ɵɵprojection(6);
    i0.ɵɵprojection(7, 1);
    i0.ɵɵprojection(8, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.classList)("@transformMenu", ctx_r0.panelAnimationState);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.title);
} }
const _c0 = [[["xpo-popover-content"]], [["xpo-popover-item"]], "*", [["xpo-popover-title"]]];
const _c1 = ["xpo-popover-content", "xpo-popover-item", "*", "xpo-popover-title"];
/** Injection token to be used to override the default options for `mat-menu`. */
const XPO_POPOVER_DEFAULT_OPTIONS = new InjectionToken('xpo-popover-default-options', {
    providedIn: 'root',
    factory: XPO_POPOVER_DEFAULT_OPTIONS_FACTORY,
});
const OVERLAY_TRANSPARENT_BACKDROP_CLASS = 'cdk-overlay-transparent-backdrop';
/** @docs-private */
function XPO_POPOVER_DEFAULT_OPTIONS_FACTORY() {
    return {
        position: 'below',
        caretPosition: 'center',
        hasBackdrop: true,
        backdropClass: OVERLAY_TRANSPARENT_BACKDROP_CLASS,
    };
}
/**
 * Start elevation for the menu panel.
 * @docs-private
 */
const XPO_POPOVER_BASE_ELEVATION = 2;
// Directive for the Content tag
class XpoPopoverContent {
}
XpoPopoverContent.ɵfac = function XpoPopoverContent_Factory(t) { return new (t || XpoPopoverContent)(); };
XpoPopoverContent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPopoverContent, selectors: [["xpo-popover-content"]], hostAttrs: [1, "xpo-Popover-content"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverContent, [{
        type: Directive,
        args: [{
                selector: 'xpo-popover-content',
                host: { class: 'xpo-Popover-content' },
            }]
    }], null, null); })();
class XpoPopover {
    constructor(elementRef, defaultOptions) {
        this.elementRef = elementRef;
        this.defaultOptions = defaultOptions;
        this.positionValue = this.defaultOptions.position;
        this.caretPositionValue = this.defaultOptions.caretPosition;
        this.colorValue = 'primary';
        this.hideCloseButtonValue = false;
        this.triggerType = TriggerType.Click;
        /** Config object to be passed into the menu's ngClass */
        this.classList = {};
        /** Current state of the panel animation. */
        this.panelAnimationState = 'void';
        /** Emits whenever an animation on the menu completes. */
        this.animationDone = new Subject();
        /** Closing disabled on popover */
        this.closeDisabled = false;
        /** Class to be added to the backdrop element. */
        this.backdropClass = this.defaultOptions.backdropClass;
        this.hasBackdropValue = this.defaultOptions.hasBackdrop;
        // enum CloseEmitterTypes {}
        /** Event emitted when the menu is closed. */
        this.closed = new EventEmitter();
        /** Event emitted when mouse leaves the popover component if triggertype is set to hover */
        this.mouseLeaveEmitter = new EventEmitter();
    }
    get hideCloseButton() {
        return this.hideCloseButtonValue;
    }
    set hideCloseButton(value) {
        this.hideCloseButtonValue = coerceBooleanProperty(value);
    }
    /** Position of the menu in the X axis. */
    get position() {
        return this.positionValue;
    }
    set position(value) {
        if (this.positionValue !== value) {
            this.positionValue = value;
            this.setPopoverClasses();
        }
    }
    /** The x-axis or y-axis position of the caret. */
    get caretPosition() {
        return this.caretPositionValue;
    }
    set caretPosition(value) {
        if (this.caretPositionValue !== value) {
            this.caretPositionValue = value;
            this.setPopoverClasses();
        }
    }
    get color() {
        return this.colorValue;
    }
    set color(value) {
        if (this.colorValue !== value) {
            this.colorValue = value;
            this.setPopoverClasses();
        }
    }
    /** Whether the menu has a backdrop. */
    get hasBackdrop() {
        return this.hasBackdropValue;
    }
    set hasBackdrop(value) {
        this.hasBackdropValue = coerceBooleanProperty(value);
    }
    /**
     * This method takes classes set on the host xpo-popover element and applies them on the
     * menu template that displays in the overlay container.  Otherwise, it's difficult
     * to style the containing menu from outside the component.
     * @param classes list of class names
     */
    set panelClass(classes) {
        if (classes && classes.length) {
            this.classList = classes.split(' ').reduce((obj, className) => {
                obj[className] = true;
                return obj;
            }, {});
            this.elementRef.nativeElement.className = '';
        }
    }
    /** Sets the trigger action type */
    set triggerMode(action) {
        this.triggerType = action;
        if (this.triggerType === TriggerType.Hover) {
            this.hideCloseButton = true;
        }
    }
    ngOnInit() {
        this.originalPosition = this.position;
        this.setPopoverClasses();
    }
    ngOnDestroy() {
        this.closed.complete();
        this.mouseLeaveEmitter.complete();
    }
    /** Handle a keyboard event from the menu, delegating to the appropriate action. */
    handleKeydown(event) {
        const keyCode = event.code;
        switch (keyCode) {
            case ESCAPE:
                this.closed.emit(ClosedEmitterTypes.Keydown);
                event.stopPropagation();
                break;
            default:
        }
    }
    /**
     * Sets the menu panel elevation.
     * @param depth Number of parent menus that come before the menu.
     */
    setElevation(depth) {
        // The elevation starts at the base and increases by one for each level.
        const newElevation = `mat-elevation-z${XPO_POPOVER_BASE_ELEVATION + depth}`;
        const customElevation = Object.keys(this.classList).find((c) => c.startsWith('mat-elevation-z'));
        if (!customElevation || customElevation === this.previousElevationValue) {
            if (this.previousElevationValue) {
                this.classList[this.previousElevationValue] = false;
            }
            this.classList[newElevation] = true;
            this.previousElevationValue = newElevation;
        }
    }
    /**
     * Adds classes to the popover panel based on its position. Can be used by
     * consumers to add specific styling based on the position.
     * @docs-private
     */
    setPopoverClasses() {
        const classes = this.classList;
        classes['xpo-Popover--before'] = this.positionValue === 'before';
        classes['xpo-Popover--after'] = this.positionValue === 'after';
        classes['xpo-Popover--above'] = this.positionValue === 'above';
        classes['xpo-Popover--below'] = this.positionValue === 'below';
        classes['xpo-Popover--primary'] = this.colorValue === 'primary';
        classes['xpo-Popover--accent'] = this.colorValue === 'accent';
        classes['xpo-Popover-caret--top'] =
            (this.caretPositionValue === 'top' || this.caretPositionValue === 'start') && (this.positionValue === 'before' || this.positionValue === 'after');
        classes['xpo-Popover-caret--bottom'] =
            (this.caretPositionValue === 'bottom' || this.caretPositionValue === 'end') && (this.positionValue === 'before' || this.positionValue === 'after');
        classes['xpo-Popover-caret--verticalCenter'] = this.caretPositionValue === 'center' && (this.positionValue === 'before' || this.positionValue === 'after');
        classes['xpo-Popover-caret--start'] =
            (this.caretPositionValue === 'top' || this.caretPositionValue === 'start') && (this.positionValue === 'above' || this.positionValue === 'below');
        classes['xpo-Popover-caret--end'] =
            (this.caretPositionValue === 'bottom' || this.caretPositionValue === 'end') && (this.positionValue === 'above' || this.positionValue === 'below');
        classes['xpo-Popover-caret--horizontalCenter'] = this.caretPositionValue === 'center' && (this.positionValue === 'above' || this.positionValue === 'below');
        classes['xpo-Popover--hasTitle'] = !!this.title;
    }
    /** Starts the enter animation. */
    startAnimation() {
        // @deletion-target 7.0.0 Combine with resetAnimation.
        this.panelAnimationState = 'enter';
    }
    /** Resets the panel animation to its initial state. */
    resetAnimation() {
        // @deletion-target 7.0.0 Combine with startAnimation.
        this.panelAnimationState = 'void';
    }
    /** Callback that is invoked when the panel animation completes. */
    onAnimationDone(event) {
        this.animationDone.next(event);
        this.isAnimating = false;
    }
    resetPosition() {
        this.position = this.originalPosition;
    }
    /** Enables close of popover when mouse leaving popover element */
    onMouseLeave() {
        if (this.triggerType === TriggerType.Hover) {
            this.closeDisabled = false;
            this.mouseLeaveEmitter.emit();
        }
    }
    /** Disables close of popover when leaving trigger element and mouse over the popover */
    onMouseOver() {
        if (this.triggerType === TriggerType.Hover) {
            this.closeDisabled = true;
        }
    }
}
XpoPopover.ɵfac = function XpoPopover_Factory(t) { return new (t || XpoPopover)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(XPO_POPOVER_DEFAULT_OPTIONS)); };
XpoPopover.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoPopover, selectors: [["xpo-popover"]], contentQueries: function XpoPopover_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MatMenuContent, 5);
        i0.ɵɵcontentQuery(dirIndex, XpoPopoverTitle, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lazyContent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.title = _t.first);
    } }, viewQuery: function XpoPopover_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, hostAttrs: [1, "xpo-Popover"], inputs: { backdropClass: "backdropClass", hideCloseButton: "hideCloseButton", position: "position", caretPosition: "caretPosition", color: "color", hasBackdrop: "hasBackdrop", panelClass: ["class", "panelClass"], triggerMode: ["triggerOn", "triggerMode"] }, outputs: { closed: "closed", mouseLeaveEmitter: "mouseLeaveEmitter" }, exportAs: ["xpoPopover"], ngContentSelectors: _c1, decls: 1, vars: 0, consts: [["tabindex", "-1", "role", "menu", 1, "xpo-Popover-panel", 3, "ngClass", "keydown", "mouseleave", "mouseover"], [1, "xpo-Popover-caret"], ["xmlns", "http://www.w3.org/2000/svg", 1, "xpo-Popover-caret-svg"], ["points", "0,0 16,0 8,8"], [1, "mat-menu-content", "xpo-Popover-wrapper"], ["class", "xpo-Popover-header", 4, "ngIf"], [1, "xpo-Popover-header"], ["class", "xpo-Popover-header-closeButton", "mat-icon-button", "", "xpo-popover-close", "", 4, "ngIf"], ["mat-icon-button", "", "xpo-popover-close", "", 1, "xpo-Popover-header-closeButton"]], template: function XpoPopover_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵtemplate(0, XpoPopover_ng_template_0_Template, 9, 3, "ng-template");
    } }, styles: [".flex--stretch{flex:1}.xpo-Popover-panel{outline:none!important}.xpo-Popover--before{margin:0 16px}.xpo-Popover--before .xpo-Popover-caret{right:-16px;transform:rotate(270deg) translate(8px)}.xpo-Popover--after{margin:0 16px}.xpo-Popover--after .xpo-Popover-caret{left:-16px;transform:rotate(90deg) translate(-8px)}.xpo-Popover--above{bottom:16px}.xpo-Popover--above .xpo-Popover-caret{bottom:-16px;transform:translate(-8px)}.xpo-Popover--below{top:16px}.xpo-Popover--below .xpo-Popover-caret{top:-16px;transform:rotate(180deg) translate(8px)}.xpo-Popover--below.xpo-Popover--accent.xpo-Popover--hasTitle.xpo-Popover--accent .xpo-Popover-caret-svg,.xpo-Popover--below.xpo-Popover--primary.xpo-Popover--hasTitle.xpo-Popover--accent .xpo-Popover-caret-svg{filter:none}.xpo-Popover--below.xpo-Popover--accent.xpo-Popover--hasTitle.xpo-Popover--accent .xpo-Popover-caret polygon,.xpo-Popover--below.xpo-Popover--primary.xpo-Popover--hasTitle.xpo-Popover--accent .xpo-Popover-caret polygon{fill:#4a4a4a}.xpo-Popover--below.xpo-Popover--accent.xpo-Popover--hasTitle .xpo-Popover-caret-svg,.xpo-Popover--below.xpo-Popover--primary.xpo-Popover--hasTitle .xpo-Popover-caret-svg{filter:none}.xpo-Popover--below.xpo-Popover--accent.xpo-Popover--hasTitle .xpo-Popover-caret polygon,.xpo-Popover--below.xpo-Popover--primary.xpo-Popover--hasTitle .xpo-Popover-caret polygon{fill:#d8d8d8}.xpo-Popover-caret--top .xpo-Popover-caret{top:16px}.xpo-Popover-caret--top.xpo-Popover--accent .xpo-Popover-caret-svg{filter:none}.xpo-Popover-caret--top.xpo-Popover--accent .xpo-Popover-caret polygon{fill:#4a4a4a}.xpo-Popover-caret--top.xpo-Popover--primary .xpo-Popover-caret-svg{filter:none}.xpo-Popover-caret--top.xpo-Popover--primary .xpo-Popover-caret polygon{fill:#d8d8d8}.xpo-Popover-caret--bottom .xpo-Popover-caret{bottom:0}.xpo-Popover-caret--verticalCenter .xpo-Popover-caret{top:50%}.xpo-Popover-caret--start .xpo-Popover-caret{left:16px}.xpo-Popover-caret--end .xpo-Popover-caret{right:0}.xpo-Popover-caret--horizontalCenter .xpo-Popover-caret{left:50%}.xpo-Popover-panel{display:block;position:relative}.xpo-Popover-caret{display:flex;height:16px;position:absolute;width:16px;z-index:1}.xpo-Popover-caret-svg{filter:drop-shadow(0 1px 1px rgba(0,0,0,.4));height:8px;width:16px}.xpo-Popover-caret-svg polygon{fill:#fff}.xpo-Popover-wrapper{background-color:#fff;padding:0!important;position:relative;z-index:2}.xpo-Popover-wrapper .xpo-Popover-item{background-color:transparent;border:none;color:#6f6f6f;display:block;font-size:14px;height:1.75em;line-height:1.75em;padding:0 8px}.xpo-Popover-wrapper .xpo-Popover-item:hover,.xpo-Popover-wrapper .xpo-Popover-item:focus{color:#0d94f4;cursor:pointer}.xpo-Popover-wrapper .xpo-Popover-item:active{color:#053c63}.xpo-Popover-wrapper .xpo-Popover-item:hover,.xpo-Popover-wrapper .xpo-Popover-item:active,.xpo-Popover-wrapper .xpo-Popover-item:focus,.xpo-Popover-wrapper .xpo-Popover-item:focus:active{border:none;outline:none}.xpo-Popover-wrapper .xpo-Popover-item:disabled{color:#9b9b9b;cursor:not-allowed}.xpo-Popover-wrapper .xpo-Popover-item.mat-button{min-width:1em}.xpo-Popover-header{align-items:center;display:flex;flex-direction:row;font-size:.875rem;font-weight:500;height:32px;justify-content:space-between;line-height:32px;padding:0 8px;position:relative}.xpo-Popover--accent .xpo-Popover-header{background-color:#4a4a4a;color:#f3f3f3}.xpo-Popover--primary .xpo-Popover-header{background-color:#d8d8d8;color:#4a4a4a}.xpo-Popover-header .xpo-Popover-title{padding-right:16px}.xpo-Popover-header-closeButton.mat-icon-button{height:auto;position:absolute;right:0;width:32px}.xpo-Popover-header-closeButton.mat-icon-button .mat-icon{font-size:1.285rem}.xpo-Popover-content{display:block;font-size:.875rem;padding:8px}.xpo-Popover-footerContainer{align-items:center;border-top:1px solid #d8d8d8;display:flex;padding:8px}.xpo-Popover-footerIcon:hover,.xpo-Popover-footerIcon:focus{cursor:pointer}.xpo-PopoverMenu-header{letter-spacing:2px;text-transform:uppercase}.xpo-PopoverMenu-content{width:272px}.xpo-PopoverMenu-content--scrollable{overflow-y:auto}.xpo-PopoverMenu-item{border-top:1px solid #d8d8d8;padding:8px}.xpo-PopoverMenu-item:first-of-type{border-top:none}.xpo-PopoverMenu-footer{border-top:1px solid #d8d8d8;display:flex;justify-content:space-between;padding:8px}.xpo-PopoverMenu-footer-icon{color:#4a4a4a;font-size:24px;line-height:32px}\n"], encapsulation: 2, data: { animation: [matMenuAnimations.transformMenu, matMenuAnimations.fadeInItems] }, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopover, [{
        type: Component,
        args: [{
                selector: 'xpo-popover',
                templateUrl: './popover.component.html',
                styleUrls: ['./popover.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-Popover',
                },
                exportAs: 'xpoPopover',
                animations: [matMenuAnimations.transformMenu, matMenuAnimations.fadeInItems],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [XPO_POPOVER_DEFAULT_OPTIONS]
            }] }]; }, { backdropClass: [{
            type: Input
        }], hideCloseButton: [{
            type: Input
        }], position: [{
            type: Input
        }], caretPosition: [{
            type: Input
        }], color: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: [TemplateRef]
        }], lazyContent: [{
            type: ContentChild,
            args: [MatMenuContent]
        }], title: [{
            type: ContentChild,
            args: [XpoPopoverTitle]
        }], hasBackdrop: [{
            type: Input
        }], panelClass: [{
            type: Input,
            args: ['class']
        }], triggerMode: [{
            type: Input,
            args: ['triggerOn']
        }], closed: [{
            type: Output
        }], mouseLeaveEmitter: [{
            type: Output
        }] }); })();

/**
 * Element that when clicked, will close the parent popover component
 */
class XpoPopoverClose {
    constructor(parentPopover) {
        this.parentPopover = parentPopover;
    }
    handleElementClicked() {
        if (this.parentPopover) {
            this.parentPopover.closed.emit();
        }
    }
}
XpoPopoverClose.ɵfac = function XpoPopoverClose_Factory(t) { return new (t || XpoPopoverClose)(i0.ɵɵdirectiveInject(XpoPopover)); };
XpoPopoverClose.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPopoverClose, selectors: [["", "xpo-popover-close", ""]], hostAttrs: [1, "xpo-Popover-close"], hostBindings: function XpoPopoverClose_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function XpoPopoverClose_click_HostBindingHandler() { return ctx.handleElementClicked(); });
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverClose, [{
        type: Directive,
        args: [{
                selector: '[xpo-popover-close]',
                host: {
                    class: 'xpo-Popover-close',
                },
            }]
    }], function () { return [{ type: XpoPopover }]; }, { handleElementClicked: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class XpoPopoverItem {
    constructor(parentPopover, el) {
        this.parentPopover = parentPopover;
        this.el = el;
    }
    // close popover on select, if the popover-item is button
    handleElementClicked() {
        if (this.el.nativeElement.nodeName === 'BUTTON' && this.parentPopover) {
            this.parentPopover.closed.emit(ClosedEmitterTypes.Click);
        }
    }
}
XpoPopoverItem.ɵfac = function XpoPopoverItem_Factory(t) { return new (t || XpoPopoverItem)(i0.ɵɵdirectiveInject(XpoPopover), i0.ɵɵdirectiveInject(i0.ElementRef)); };
XpoPopoverItem.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPopoverItem, selectors: [["", "xpo-popover-item", ""]], hostAttrs: [1, "xpo-Popover-item"], hostBindings: function XpoPopoverItem_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function XpoPopoverItem_click_HostBindingHandler() { return ctx.handleElementClicked(); });
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverItem, [{
        type: Directive,
        args: [{
                selector: '[xpo-popover-item]',
                host: { class: 'xpo-Popover-item' },
            }]
    }], function () { return [{ type: XpoPopover }, { type: i0.ElementRef }]; }, { handleElementClicked: [{
            type: HostListener,
            args: ['click']
        }] }); })();

var MouseEventType;
(function (MouseEventType) {
    MouseEventType["Enter"] = "enter";
    MouseEventType["Leave"] = "leave";
})(MouseEventType || (MouseEventType = {}));

var VerticalPosition;
(function (VerticalPosition) {
    VerticalPosition["Above"] = "above";
    VerticalPosition["Below"] = "below";
})(VerticalPosition || (VerticalPosition = {}));
var HorizontalPosition;
(function (HorizontalPosition) {
    HorizontalPosition["After"] = "after";
    HorizontalPosition["Before"] = "before";
})(HorizontalPosition || (HorizontalPosition = {}));

/**
 * (Ancel):
 *
 * Created this component by taking pieces of Material's Menu component(https://material.angular.io/components/menu) and
 * Tooltip component (https://material.angular.io/components/tooltip/)
 *
 * For the XpoPopoverTrigger i utilized the functionality
 * of MenuTrigger component with the positioning logic of the Tooltip component.
 *
 */
/** Injection token that determines the scroll handling while the menu is open. */
const XPO_MENU_SCROLL_STRATEGY = new InjectionToken('xpo-panel-scroll-strategy');
/** @docs-private */
function XPO_POPOVER_SCROLL_STRATEGY_FACTORY(overlay) {
    return () => overlay.scrollStrategies.reposition();
}
/** @docs-private */
const XPO_POPOVER_SCROLL_STRATEGY_FACTORY_PROVIDER = {
    provide: XPO_MENU_SCROLL_STRATEGY,
    deps: [Overlay],
    useFactory: XPO_POPOVER_SCROLL_STRATEGY_FACTORY,
};
/** Default top padding of the menu panel. */
const MENU_PANEL_TOP_PADDING = 8;
/**
 * This directive is intended to be used in conjunction with an xpo-popover tag.  It is
 * responsible for toggling the display of the provided menu instance.
 */
class XpoPopoverTrigger {
    constructor(overlay, element, viewContainerRef, scrollStrategy, dirValue, focusMonitor) {
        this.overlay = overlay;
        this.element = element;
        this.viewContainerRef = viewContainerRef;
        this.scrollStrategy = scrollStrategy;
        this.dirValue = dirValue;
        this.focusMonitor = focusMonitor;
        this.overlayRef = null;
        this.menuOpenValue = false;
        this.closeSubscription = Subscription.EMPTY;
        this.hoverSubscription = Subscription.EMPTY;
        this.mouseEventSource = new Subject();
        // Tracking input type is necessary so it's possible to only auto-focus
        // the first item of the list when the menu is opened via the keyboard
        this.openedByMouse = false;
        /** Event emitted when the associated menu is opened. */
        this.menuOpened = new EventEmitter();
        /**
         * Event emitted when the associated menu is opened.
         * @deprecated Switch to `menuOpened` instead
         * @deletion-target 7.0.0
         */
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onMenuOpen = this.menuOpened;
        /** Event emitted when the associated menu is closed. */
        this.menuClosed = new EventEmitter();
        /**
         * Event emitted when the associated menu is closed.
         * @deprecated Switch to `menuClosed` instead
         * @deletion-target 7.0.0
         */
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onMenuClose = this.menuClosed;
    }
    get menuDisabled() {
        return this.menuDisabledValue;
    }
    set menuDisabled(value) {
        this.menuDisabledValue = coerceBooleanProperty(value);
    }
    ngAfterContentInit() {
        this.checkMenu();
        this.menu.closed.subscribe(() => {
            this.destroyMenu();
        });
        if (this.positionIsVertical(this.menu.position)) {
            this.cachedOverlayXPosition = HorizontalPosition.Before;
            this.cachedOverlayYPosition = this.menu.position;
        }
        else {
            this.cachedOverlayXPosition = this.menu.position;
            this.cachedOverlayYPosition = VerticalPosition.Below;
        }
        this.menu.mouseLeaveEmitter.subscribe(() => this.closeMenu());
        this.initMouseEventWatcher();
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
        this.cleanUpSubscriptions();
    }
    /** Whether the menu is open. */
    get menuOpen() {
        return this.menuOpenValue;
    }
    /** The text direction of the containing app. */
    get dir() {
        return this.dirValue && this.dirValue.value === 'rtl' ? 'rtl' : 'ltr';
    }
    /** Toggles the menu between the open and closed states. */
    toggleMenu() {
        return this.menuOpenValue ? this.closeMenu() : this.openMenu();
    }
    /** Opens the menu. */
    openMenu() {
        if (this.menuOpenValue || this.menuDisabled) {
            return;
        }
        const overlayRef = this.createOverlay();
        overlayRef.attach(this.portal);
        if (this.menu.lazyContent) {
            this.menu.lazyContent.attach(this.menuData);
        }
        this.closeSubscription = this.menuClosingActions().subscribe(() => {
            this.closeMenu();
        });
        this.initMenu();
        if (this.menu instanceof XpoPopover) {
            this.menu.startAnimation();
        }
    }
    /** Closes the menu. */
    closeMenu() {
        this.menu.resetPosition();
        this.menu.closed.emit();
    }
    /**
     * Focuses the menu trigger.
     * @param origin Source of the menu trigger's focus.
     */
    focus(origin = 'program') {
        if (this.focusMonitor) {
            this.focusMonitor.focusVia(this.element.nativeElement, origin);
        }
        else {
            this.element.nativeElement.focus();
        }
    }
    /** Closes the menu and does the necessary cleanup. */
    destroyMenu() {
        if (!this.overlayRef || !this.menuOpen) {
            return;
        }
        const menu = this.menu;
        this.closeSubscription.unsubscribe();
        this.overlayRef.detach();
        menu.resetAnimation();
        if (menu.lazyContent) {
            // Wait for the exit animation to finish before detaching the content.
            menu.animationDone
                .pipe(filter((event) => event.toState === 'void'), take(1))
                .subscribe(() => {
                menu.lazyContent.detach();
                this.resetMenu();
            });
        }
        else {
            this.resetMenu();
        }
    }
    /**
     * This method sets the menu state to open and focuses the first item if
     * the menu was opened via the keyboard.
     */
    initMenu() {
        this.menu.direction = this.dir;
        this.setMenuElevation();
        this.setIsMenuOpen(true);
    }
    /** Updates the menu elevation based on the amount of parent menus that it has. */
    setMenuElevation() {
        if (this.menu.setElevation) {
            this.menu.setElevation(0);
        }
    }
    /**
     * This method resets the menu when it's closed, most importantly restoring
     * focus to the menu trigger if the menu was opened via the keyboard.
     */
    resetMenu() {
        this.setIsMenuOpen(false);
        // We should reset focus if the user is navigating using a keyboard or
        // if we have a top-level trigger which might cause focus to be lost
        // when clicking on the backdrop.
        if (!this.openedByMouse) {
            // Note that the focus style will show up both for `program` and
            // `keyboard` so we don't have to specify which one it is.
            this.focus();
        }
        this.openedByMouse = false;
    }
    // set state rather than toggle to support triggers sharing a menu
    setIsMenuOpen(isOpen) {
        this.menuOpenValue = isOpen;
        this.menuOpenValue ? this.menuOpened.emit() : this.menuClosed.emit();
    }
    /**
     * This method checks that a valid instance of MatMenu has been passed into
     * matMenuTriggerFor. If not, an exception is thrown.
     */
    checkMenu() {
        if (!this.menu) {
            // throwMatMenuMissingError();
        }
    }
    /**
     * This method creates the overlay from the provided menu's template and saves its
     * OverlayRef so that it can be attached to the DOM when openMenu is called.
     */
    createOverlay() {
        if (!this.overlayRef) {
            this.portal = new TemplatePortal(this.menu.templateRef, this.viewContainerRef);
            const config = this.getOverlayConfig();
            this.overlayRef = this.overlay.create(config);
            this.subscribeToPositions(config.positionStrategy);
        }
        else if (this.overlayRef && (this.menu.position !== this.cachedMenuPosition || this.menu.caretPosition !== this.cachedCaretPosition)) {
            // Updating the overlay of the menu when the menu position value changes.
            this.updatePosition();
            this.cachedMenuPosition = this.menu.position;
            this.cachedCaretPosition = this.menu.caretPosition;
        }
        return this.overlayRef;
    }
    /**
     * Listens to changes in the position of the overlay and sets the correct classes
     * on the popover based on the new position. This ensures the animation origin is always
     * correct, even if a fallback position is used for the overlay.
     */
    subscribeToPositions(position) {
        this.positionSubscription = position.positionChanges.subscribe((change) => {
            const positionX = change.connectionPair.overlayX === 'start' ? HorizontalPosition.After : HorizontalPosition.Before;
            const positionY = change.connectionPair.overlayY === 'top' ? VerticalPosition.Below : VerticalPosition.Above;
            if (!this.positionIsVertical(this.menu.position) && this.cachedOverlayXPosition !== positionX) {
                this.menu.position = positionX;
                this.cachedOverlayXPosition = positionX;
            }
            else if (this.positionIsVertical(this.menu.position) && this.cachedOverlayYPosition !== positionY) {
                this.menu.position = positionY;
                this.cachedOverlayYPosition = positionY;
            }
        });
    }
    /** Updates the position of the current tooltip. */
    updatePosition() {
        const position = this.overlayRef.getConfig().positionStrategy;
        const origin = this.getOrigin();
        const overlay = this.getOverlayPosition();
        position.withPositions([
            Object.assign(Object.assign({}, origin.main), overlay.main),
            Object.assign(Object.assign({}, origin.fallback), overlay.fallback),
        ]);
    }
    /**
     * This method builds the configuration object needed to create the overlay, the OverlayState.
     * @returns OverlayConfig
     */
    getOverlayConfig() {
        const overlayState = { positionStrategy: this.getPosition() };
        if (this.menu.triggerType === TriggerType.Click) {
            overlayState.hasBackdrop = true;
            overlayState.backdropClass = OVERLAY_TRANSPARENT_BACKDROP_CLASS;
        }
        overlayState.scrollStrategy = this.scrollStrategy();
        overlayState.direction = this.dirValue;
        return overlayState;
    }
    /**
     * This method builds the position strategy for the overlay, so the menu is properly connected
     * to the trigger.
     * @returns ConnectedPositionStrategy
     */
    getPosition() {
        const origin = this.getOrigin();
        const overlay = this.getOverlayPosition();
        return this.overlay
            .position()
            .flexibleConnectedTo(this.element)
            .withTransformOriginOn('.xpo-Popover-panel')
            .withPositions([
            Object.assign(Object.assign({}, origin.main), overlay.main),
            Object.assign(Object.assign({}, origin.fallback), overlay.fallback),
        ]);
    }
    /**
     * Returns the origin position and a fallback position based on the user's position preference.
     * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
     */
    getOrigin() {
        const isLtr = !this.dirValue || this.dirValue.value === 'ltr';
        const position = this.menu.position;
        let originPosition;
        if (position === VerticalPosition.Above || position === VerticalPosition.Below) {
            originPosition = {
                originX: this.getHorizontalPositionFromCaretOptions(this.menu.caretPosition),
                originY: position === VerticalPosition.Above ? 'top' : 'bottom',
            };
        }
        else if (position === HorizontalPosition.Before || (position === 'left' && isLtr) || (position === 'right' && !isLtr)) {
            originPosition = {
                originX: 'start',
                originY: this.getVerticalPositionFromCaretOptions(this.menu.caretPosition),
            };
        }
        else if (position === HorizontalPosition.After || (position === 'right' && isLtr) || (position === 'left' && !isLtr)) {
            originPosition = { originX: 'end', originY: this.getVerticalPositionFromCaretOptions(this.menu.caretPosition) };
        }
        else {
            // throw getMatTooltipInvalidPositionError(position);
        }
        const { x, y } = this.invertPosition(originPosition.originX, originPosition.originY);
        return {
            main: originPosition,
            fallback: { originX: x, originY: y },
        };
    }
    /** Returns the overlay position and a fallback position based on the user's preference */
    getOverlayPosition() {
        const isLtr = !this.dirValue || this.dirValue.value === 'ltr';
        const position = this.menu.position;
        let overlayPosition;
        if (position === VerticalPosition.Above) {
            overlayPosition = {
                overlayX: this.getHorizontalPositionFromCaretOptions(this.menu.caretPosition),
                overlayY: 'bottom',
            };
        }
        else if (position === VerticalPosition.Below) {
            overlayPosition = {
                overlayX: this.getHorizontalPositionFromCaretOptions(this.menu.caretPosition),
                overlayY: 'top',
            };
        }
        else if (position === HorizontalPosition.Before || (position === 'left' && isLtr) || (position === 'right' && !isLtr)) {
            overlayPosition = {
                overlayX: 'end',
                overlayY: this.getVerticalPositionFromCaretOptions(this.menu.caretPosition),
            };
        }
        else if (position === HorizontalPosition.After || (position === 'right' && isLtr) || (position === 'left' && !isLtr)) {
            overlayPosition = {
                overlayX: 'start',
                overlayY: this.getVerticalPositionFromCaretOptions(this.menu.caretPosition),
            };
        }
        else {
            // throw getMatTooltipInvalidPositionError(position);
        }
        const { x, y } = this.invertPosition(overlayPosition.overlayX, overlayPosition.overlayY);
        return {
            main: overlayPosition,
            fallback: { overlayX: x, overlayY: y },
        };
    }
    // tslint:enable:triple-equals
    getHorizontalPositionFromCaretOptions(caretPosition) {
        if (caretPosition === 'top') {
            caretPosition = 'start';
        }
        else if (caretPosition === 'bottom') {
            caretPosition = 'end';
        }
        return caretPosition;
    }
    getVerticalPositionFromCaretOptions(caretPosition) {
        if (caretPosition === 'start') {
            caretPosition = 'top';
        }
        else if (caretPosition === 'end') {
            caretPosition = 'bottom';
        }
        return caretPosition;
    }
    /** Inverts an overlay position. */
    invertPosition(x, y) {
        if (this.menu.position === VerticalPosition.Above || this.menu.position === VerticalPosition.Below) {
            if (y === 'top') {
                y = 'bottom';
            }
            else if (y === 'bottom') {
                y = 'top';
            }
        }
        else {
            if (x === 'end') {
                x = 'start';
            }
            else if (x === 'start') {
                x = 'end';
            }
        }
        return { x, y };
    }
    /** Cleans up the active subscriptions. */
    cleanUpSubscriptions() {
        this.closeSubscription.unsubscribe();
        this.hoverSubscription.unsubscribe();
        if (this.positionSubscription) {
            this.positionSubscription.unsubscribe();
        }
    }
    /** Returns a stream that emits whenever an action that should close the menu occurs. */
    menuClosingActions() {
        const backdrop = this.overlayRef.backdropClick();
        const detachments = this.overlayRef.detachments();
        return merge(backdrop, detachments);
    }
    /** Handles mouse presses on the trigger. */
    handleMousedown(event) {
        if (!isFakeMousedownFromScreenReader(event)) {
            this.openedByMouse = true;
        }
    }
    /** Handles key presses on the trigger. */
    handleKeydown(event) {
        const keyCode = event.code;
        if ((keyCode === RIGHT_ARROW && this.dir === 'ltr') || (keyCode === LEFT_ARROW && this.dir === 'rtl')) {
            this.openMenu();
        }
    }
    /** Handles click events on the trigger. */
    handleClick() {
        this.toggleMenu();
    }
    /** Handles mouse over event */
    handleMouseEnter() {
        if (this.menu.triggerType === TriggerType.Hover) {
            this.mouseEventSource.next(MouseEventType.Enter);
        }
    }
    /** Handles mouse leave event */
    handleMouseLeave() {
        if (this.menu.triggerType === TriggerType.Hover) {
            this.mouseEventSource.next(MouseEventType.Leave);
        }
    }
    initMouseEventWatcher() {
        /** Delay added to allow pointer to travel from trigger to popover without triggering closeMenu() */
        this.hoverSubscription = this.mouseEventSource.pipe(delay(500)).subscribe((action) => {
            if (action === MouseEventType.Leave && this.menuOpenValue && !this.menu.closeDisabled) {
                this.closeMenu();
            }
            if (action === MouseEventType.Enter && !this.menuOpenValue) {
                this.openMenu();
            }
        });
    }
    positionIsVertical(position) {
        return position === VerticalPosition.Above || position === VerticalPosition.Below;
    }
}
XpoPopoverTrigger.ɵfac = function XpoPopoverTrigger_Factory(t) { return new (t || XpoPopoverTrigger)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(XPO_MENU_SCROLL_STRATEGY), i0.ɵɵdirectiveInject(i2.Directionality, 8), i0.ɵɵdirectiveInject(i3.FocusMonitor)); };
XpoPopoverTrigger.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoPopoverTrigger, selectors: [["", "xpoPopoverTriggerFor", ""]], hostAttrs: ["aria-haspopup", "true"], hostVars: 1, hostBindings: function XpoPopoverTrigger_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mousedown", function XpoPopoverTrigger_mousedown_HostBindingHandler($event) { return ctx.handleMousedown($event); })("keydown", function XpoPopoverTrigger_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); })("click", function XpoPopoverTrigger_click_HostBindingHandler() { return ctx.handleClick(); })("mouseenter", function XpoPopoverTrigger_mouseenter_HostBindingHandler() { return ctx.handleMouseEnter(); })("mouseleave", function XpoPopoverTrigger_mouseleave_HostBindingHandler() { return ctx.handleMouseLeave(); });
    } if (rf & 2) {
        i0.ɵɵattribute("aria-expanded", ctx.menuOpen || !ctx.menuOpen);
    } }, inputs: { menu: ["xpoPopoverTriggerFor", "menu"], menuData: ["xpoMenuTriggerData", "menuData"], menuDisabled: ["xpoPopoverDisabled", "menuDisabled"] }, outputs: { menuOpened: "menuOpened", onMenuOpen: "onMenuOpen", menuClosed: "menuClosed", onMenuClose: "onMenuClose" }, exportAs: ["xpoPopoverTrigger"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverTrigger, [{
        type: Directive,
        args: [{
                selector: '[xpoPopoverTriggerFor]',
                host: {
                    'aria-haspopup': 'true',
                    '[attr.aria-expanded]': 'menuOpen || !menuOpen',
                    '(mousedown)': 'handleMousedown($event)',
                    '(keydown)': 'handleKeydown($event)',
                    '(click)': 'handleClick()',
                    '(mouseenter)': 'handleMouseEnter()',
                    '(mouseleave)': 'handleMouseLeave()',
                },
                exportAs: 'xpoPopoverTrigger',
            }]
    }], function () { return [{ type: i1.Overlay }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [XPO_MENU_SCROLL_STRATEGY]
            }] }, { type: i2.Directionality, decorators: [{
                type: Optional
            }] }, { type: i3.FocusMonitor }]; }, { menu: [{
            type: Input,
            args: ['xpoPopoverTriggerFor']
        }], menuData: [{
            type: Input,
            args: ['xpoMenuTriggerData']
        }], menuDisabled: [{
            type: Input,
            args: ['xpoPopoverDisabled']
        }], menuOpened: [{
            type: Output
        }], onMenuOpen: [{
            type: Output
        }], menuClosed: [{
            type: Output
        }], onMenuClose: [{
            type: Output
        }] }); })();

class XpoPopoverModule {
    constructor() { }
}
XpoPopoverModule.ɵfac = function XpoPopoverModule_Factory(t) { return new (t || XpoPopoverModule)(); };
XpoPopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoPopoverModule });
XpoPopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [XPO_POPOVER_SCROLL_STRATEGY_FACTORY_PROVIDER], imports: [[CommonModule, MatMenuModule, MatIconModule, MatButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoPopoverModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoPopover, XpoPopoverTrigger, XpoPopoverTitle, XpoPopoverClose, XpoPopoverContent, XpoPopoverItem],
                imports: [CommonModule, MatMenuModule, MatIconModule, MatButtonModule],
                exports: [XpoPopover, XpoPopoverTrigger, XpoPopoverTitle, XpoPopoverClose, XpoPopoverContent, XpoPopoverItem],
                providers: [XPO_POPOVER_SCROLL_STRATEGY_FACTORY_PROVIDER],
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoPopoverModule, { declarations: [XpoPopover, XpoPopoverTrigger, XpoPopoverTitle, XpoPopoverClose, XpoPopoverContent, XpoPopoverItem], imports: [CommonModule, MatMenuModule, MatIconModule, MatButtonModule], exports: [XpoPopover, XpoPopoverTrigger, XpoPopoverTitle, XpoPopoverClose, XpoPopoverContent, XpoPopoverItem] }); })();
i0.ɵɵsetComponentScope(XpoPopover, [i1$1.NgClass, i1$1.NgIf, i2$1.MatButton, XpoPopoverClose, i3$1.MatIcon], []);

/**
 * Generated bundle index. Do not edit.
 */

export { MENU_PANEL_TOP_PADDING, OVERLAY_TRANSPARENT_BACKDROP_CLASS, XPO_MENU_SCROLL_STRATEGY, XPO_POPOVER_DEFAULT_OPTIONS, XPO_POPOVER_DEFAULT_OPTIONS_FACTORY, XPO_POPOVER_SCROLL_STRATEGY_FACTORY, XPO_POPOVER_SCROLL_STRATEGY_FACTORY_PROVIDER, XpoPopover, XpoPopoverClose, XpoPopoverContent, XpoPopoverItem, XpoPopoverModule, XpoPopoverTitle, XpoPopoverTrigger };
